<template>
    <div class="management-planning-form1">
        <slot name="how-register-modal"></slot>

        <div class="edit-info" v-if="getEditionMode">
            <b-button
                :variant="getIsDarkTheme ? 'outline-light' : 'outline-dark'"
                size="sm"
                @click="changeStatusDisabled(false)"
            >
                Editar informações
            </b-button>
        </div>

        <b-form @submit.stop.prevent="onSubmit" novalidate>
            <b-form-group
                label="Indicar possibilidade de respostas"
                label-for="initiativeHas"
                class="required"
            >
                <b-form-checkbox-group
                    id="initiative-has"
                    name="initiativeHas"
                    v-model="$v.form.initiativeHas.selected.$model"
                    :options="form.initiativeHas.options"
                    value-field="item"
                    text-field="text"
                    :state="validateState('initiativeHas')"
                    :disabled="getIsDisabled"
                    @change="onChangeInitiativeHas()"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['iniciativaPossui'].value)
                    "
                ></b-form-checkbox-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['iniciativaPossui'].value"
                />

                <b-form-invalid-feedback :state="validateState('initiativeHas')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
                label="Processos de planejamento estratégico"
                label-for="hasProcess"
                class="required"
            >
                <b-form-radio-group
                    id="hasProcess"
                    name="hasProcess"
                    v-model="$v.form.hasProcess.selected.$model"
                    :options="form.hasProcess.options"
                    :state="validateState('hasProcess')"
                    stacked
                    :disabled="getIsDisabled"
                    v-if="
                        !isPlatform ||
                            (isPlatform && getAuthorizationData && getAuthorizationData['iniciativaPlanejamento'].value)
                    "
                ></b-form-radio-group>

                <NoAuthorizationMsgPP
                    v-if="isPlatform && getAuthorizationData && !getAuthorizationData['iniciativaPlanejamento'].value"
                />

                <b-form-invalid-feedback :state="validateState('hasProcess')">
                    Campo obrigatório
                </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group v-if="form.hasProcess.selected">
                <FormFilePP
                    :ref="'fileRef'"
                    :text1="textFile1"
                    :text2="textFile2"
                    :disabled="getIsDisabled"
                    :singleFile="true"
                    :previewImg="true"
                    :singleFileData="getSingleFileData()"
                    :urlSingleFileData="form.urlSingleFileData"
                    :showSingleFile="!receiveData"
                    @fileSelected="onClickFileField"
                    @removeSingleFile="removeSingleFile"
                    v-if="form.showFile"
                />

                <LockPP
                    :statusLock="form.shareLock"
                    :lockMsg="'Privado'"
                    :unlockMsg="'Público'"
                    @click="form.shareLock = Number(!form.shareLock)"
                    v-if="showLock && isImageSelected"
                />
            </b-form-group>

            <hr class="line" />

            <div class="footer-buttons">
                <slot name="platform-bottom-buttons"></slot>

                <b-button
                    :variant="'secondary'"
                    class="radius-6"
                    @click="$router.push({ name: 'AboutInitiativeForm11' })"
                    v-if="!showFooterButtons"
                    >Voltar</b-button
                >

                <b-button type="submit" :variant="'primary'" class="radius-6 submit" v-if="!showFooterButtons"
                    >Próximo</b-button
                >

                <div class="display-initial" v-if="showFooterButtons">
                    <b-button :variant="'secondary'" @click="changeRegisterForm('AboutInitiativeForm11')"
                        >Voltar</b-button
                    >

                    <b-button :variant="'primary'" @click="changeRegisterForm('ManagementPlanningForm2')">
                        Próximo
                    </b-button>
                </div>

                <b-button
                    variant="success"
                    @click=";(isUpdate = true), onSubmit()"
                    v-if="getEditionMode && !getIsDisabled"
                >
                    Salvar
                </b-button>
            </div>
        </b-form>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LockPP from '@/ui/lock-pp/LockPP'
import FormFilePP from '@/ui/form-file-pp/FormFilePP'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { ManagementPlanningApi } from '../../api/management-planning'
import { AuthorizationApi } from '../../api/admin/authorization-api'
import NoAuthorizationMsgPP from '@/ui/no-authorization-msg-pp/NoAuthorizationMsgPP'

const authorizationApi = new AuthorizationApi()
const managementPlanningApi = new ManagementPlanningApi()

export default {
    components: { LockPP, FormFilePP, DangerModalPP, NoAuthorizationMsgPP },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        editionMode: {
            type: Boolean,
            default: false
        },
        isPlatform: {
            type: Boolean,
            default: false
        },
        receiveData: {
            default: null
        },
        showFooterButtons: {
            type: Boolean,
            default: false
        },
        userIdLogged: {
            default: null
        },
        allowAuthorization: {
            type: Boolean,
            default: false
        },
        showLock: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isDisabled: null,
            textFile1: 'Tamanho de upload de imagem para 2 Mb',
            textFile2: 'Arquivos suportados: .png. .pdf, .jpg',
            currentFilesLock: false,
            management: null,
            authorizationData: null,
            imageSelected: false,
            progress: 58.17,
            message: null,
            isUpdate: false,
            form: {
                shareLock: 1,
                urlFile: null,
                singleFileData: null,
                urlSingleFileData: null,
                showFile: false,
                initiativeHas: {
                    selected: [],
                    options: [
                        {
                            text:
                                'Levantamentos diagnósticos e análises da realidade local realizado por profissional especializado',
                            item: 1,
                            value: 1
                        },
                        {
                            text:
                                'Parceria com universidades ou instituições especializadas na área de atuação de sua organização',
                            item: 2,
                            value: 2
                        },
                        { text: 'Teoria da Mudança', item: 3, value: 3 },
                        {
                            text: 'Avaliação de impacto com profissional ou instituição especializada',
                            item: 4,
                            value: 4
                        },
                        { text: 'Não se aplica', item: 5, value: 5 }
                    ]
                },
                hasProcess: {
                    selected: null,
                    options: [
                        { text: 'Sim', value: 1 },
                        { text: 'Não', value: 0 }
                    ]
                }
            }
        }
    },
    validations: {
        form: {
            initiativeHas: {
                selected: { required }
            },
            hasProcess: {
                selected: { required }
            }
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setCurrentFormPlatform', 'setProgress', 'setShowGamificationProgress']),
        validateState(nameField) {
            const { $dirty, $error } = this.$v.form[nameField]
            return $dirty ? !$error : null
        },
        fetchRead() {
            const data = this.receiveData

            this.form.initiativeHas.selected = data.iniciativaPossui || []
            this.form.hasProcess.selected = data.iniciativaPlanejamento
            this.form.shareLock = 1

            if (Object.keys(data).includes('arquivo') && data.arquivo.length) {
                this.form.shareLock = data.arquivo[0].view_arquivo

                if (data.arquivo[0].urlArquivo) {
                    this.loadingFiles(data)
                }
            }

            this.form.showFile = true

            this.filterData()
            this.fetchAuthorization()
        },
        fetch() {
            if (this.getProgress === '55.40') {
                this.setShowGamificationProgress(true)

                setTimeout(() => {
                    this.setShowGamificationProgress(false)
                }, 12000)
            }

            this.setIsLoading(true)

            axios
                .all([managementPlanningApi.listPlanGest()])
                .then(response => {
                    const data = response[0].data.data
                    if (data !== null) {
                        this.management = data
                        this.form.initiativeHas.selected = data.iniciativaPossui || []
                        this.form.hasProcess.selected = data.iniciativaPlanejamento
                        this.form.shareLock = 1

                        if (Object.keys(data).includes('arquivo') && data.arquivo.length) {
                            this.form.shareLock = data.arquivo[0].view_arquivo

                            if (data.arquivo[0].urlArquivo) {
                                this.loadingFiles(data)
                            }
                        }
                    }

                    this.form.showFile = true
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        removeSingleFile() {
            this.imageSelected = false
            this.form.urlSingleFileData = null
            this.form.urlFile = null
        },
        onSubmit(event) {
            this.$v.form.$touch()
            if (this.$v.form.$anyError) {
                return
            }

            const currentProgress = this.getProgress < this.progress ? this.progress : this.getProgress

            const data = {
                ...this.management,
                iniciativaPossui: this.form.initiativeHas.selected,
                iniciativaPlanejamento: this.form.hasProcess.selected,
                percentual: currentProgress,
                view_arquivo: this.form.shareLock,
                urlArquivo: null
            }

            delete data['arquivo']

            if (this.$refs['fileRef'] && this.$refs['fileRef'].image) {
                data.urlArquivo = this.$refs['fileRef'] ? this.$refs['fileRef'].image : null
            } else {
                data.urlArquivo = this.form.urlFile
            }

            this.setIsLoading(true)

            const request = this.isUpdate
                ? managementPlanningApi.updatePlanGest(data)
                : managementPlanningApi.createPlanGest(data)

            request
                .then(response => {
                    this.setProgress(data.percentual)

                    if (this.isUpdate) {
                        this.changeStatusDisabled(true)
                    } else {
                        this.$router.push({ name: 'ManagementPlanningForm2' })
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => this.setIsLoading(false))
        },
        loadingFiles(data) {
            this.form.singleFileData = {
                name: data.arquivo[0].urlArquivo.split('.')[0],
                type: data.arquivo[0].urlArquivo.split('.')[1]
            }

            this.form.urlSingleFileData = this.$PPP_URL_FILE + data.arquivo[0].urlArquivo
            this.form.urlFile = data.arquivo[0].urlArquivo
        },
        getSingleFileData() {
            return this.form.singleFileData
        },
        changeStatusDisabled(status) {
            this.isDisabled = status
        },
        changeRegisterForm(formName) {
            this.setCurrentFormPlatform(formName)
            this.scrollBehavior()
        },
        scrollBehavior(to, from, savedPosition) {
            const ele = document.getElementById('top-register-painel')
            return window.scrollTo({
                top: ele.offsetTop,
                behavior: 'smooth'
            })
        },
        onChangeInitiativeHas() {
            if (this.form.initiativeHas.selected.includes(5)) {
                this.form.initiativeHas.selected = [5]
            }
        },
        fetchAuthorization() {
            if (this.allowAuthorization) {
                this.setIsLoading(true)

                authorizationApi
                    .getManagementPlanning(this.userIdLogged)
                    .then(response => {
                        if (response.data.data === null || response.data.data.length === 0) {
                            this.authorizationData = null
                        } else {
                            this.authorizationData = response.data.data
                        }
                    })
                    .catch(error => {
                        this.message = error.response.data.message
                        this.$refs.warningModal.showModal()
                    })
                    .finally(() => {
                        this.setIsLoading(false)
                    })
            }
        },
        onClickFileField(value) {
            this.imageSelected = value
        },
        filterData() {
            if (this.receiveData) {
                this.form.initiativeHas.options = this.form.initiativeHas.options.filter(x =>
                    this.form.initiativeHas.selected.includes(x.value)
                )

                this.form.hasProcess.options = this.form.hasProcess.options.filter(
                    x => Number(this.form.hasProcess.selected) === x.value
                )
            }
        }
    },
    computed: {
        getEditionMode() {
            return this.editionMode
        },
        getIsDisabled() {
            return this.isDisabled
        },
        getProgress() {
            return this.$store.state.progress
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getAuthorizationData() {
            return this.authorizationData
        },
        isImageSelected() {
            return this.imageSelected || this.form.urlFile
        }
    },
    created() {
        this.isDisabled = this.disabled
        this.receiveData === null ? this.fetch() : this.fetchRead()
    }
}
</script>

<style scope src="./ManagementPlanningForm1-light-theme.css"></style>



// WEBPACK FOOTER //
// src/components/register-management-planning-forms/ManagementPlanningForm1.vue